/**
 * Route literals that more than one file depends on, and only one of those
 * files is code.
 *
 * `index.html` -- the framework-free landing page, which ships no script at
 * all -- links to sign-up on its call to action. The landing is served from
 * the apex and the application from `app.`, so that link is absolute and
 * crosses an origin; `src/landing/constants.ts` builds it from `APP_ORIGIN`
 * and the literal below, and `__tests__/paths.test.ts` reads `index.html` and
 * asserts the two agree. Inferring it from a filename is what shipped a dead
 * button once.
 *
 * Separate from `./index.ts` so the shell can link to sign-in without importing
 * the composition that imports the shell.
 */

/**
 * Where the tenant application is mounted, as `createRouter`'s `basepath`.
 *
 * Empty, because the application owns its origin (`app.socialsource.com.br`)
 * and every path below is therefore the whole path. It exists as a constant
 * rather than not at all because the alternative is what this replaced: the
 * mount point spelled into every route literal, every `<Link to>`, every
 * assertion and one path in another repository, so that moving it was a sweep
 * through fifty files instead of an edit here. `basepath` is what makes the
 * literals below relative -- TanStack strips it from an incoming URL before
 * matching and prepends it to every href it builds.
 */
export const APP_BASEPATH = '';

export const AUTH_ROUTE_PATHS = {
  signIn: '/sign-in',
  signUp: '/sign-up',
  resetPassword: '/reset-password',
} as const;

/** The application's front door: where sign-in lands, before a campaign is
 *  chosen. */
export const HOME_PATH = '/';
